import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { DialogTopBar } from './DialogTopBar';
import { Button } from './ui/button';
import { Check, Eraser } from 'lucide-react';
import { toast } from 'sonner';

const SignatureModal = ({ open, onOpenChange, title = 'Add Signature', onSave }) => {
    const ref = useRef(null);

    const handleSave = () => {
        if (!ref.current || ref.current.isEmpty()) {
            toast.error('Please provide a signature');
            return;
        }
        const data = ref.current.getTrimmedCanvas().toDataURL('image/png');
        onSave(data);
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md" data-testid="signature-modal">
                <DialogTopBar title={<>{title}</>}>
    <Button size="sm" variant="outline" onClick={() => ref.current && ref.current.clear()} data-testid="clear-signature-btn">
                        <Eraser className="w-4 h-4 mr-1" /> Clear
                    </Button>
                    <Button size="sm" onClick={handleSave}  data-testid="confirm-signature-btn">
                        <Check className="w-4 h-4 mr-1" /> Save Signature
                    </Button>
</DialogTopBar>
                <div className="border-2 border-dashed border-gray-300 rounded-lg bg-white">
                    <SignatureCanvas
                        ref={ref}
                        canvasProps={{ width: 420, height: 160, className: 'w-full rounded-lg' }}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default SignatureModal;
